// Mock data for Muhd Aiman Financial Consultant Landing Page

export const companyInfo = {
  name: "Muhd Aiman Financial Consultant",
  phone: "011-3528 0763",
  phoneFormatted: "011-3528 0763",
  whatsappNumber: "601135280763",
  email: "pembiayaanperibadi@aimanconsultant.com",
  location: "Sarawak, Malaysia"
};

export const heroContent = {
  headline: "POTONGAN GAJI MELEBIHI 60%?",
  subheadline: "Khas untuk Penjawat Awam, Badan Berkanun, Polis & Tentera di Sarawak.",
  primaryCTA: "SEMAKAN PERCUMA SEKARANG",
  secondaryCTA: "WHATSAPP SEKARANG",
  backgroundImage: "https://images.pexels.com/photos/34511142/pexels-photo-34511142.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  trustBadges: [
    "Semakan Percuma",
    "Maklumat Sulit",
    "Proses Mudah",
    "Khas Penjawat Awam"
  ]
};

export const problemSection = {
  title: "Adakah Anda Menghadapi Masalah Ini?",
  problems: [
    "Potongan gaji melebihi 60%",
    "Banyak komitmen aktif",
    "Gaji masuk terus habis",
    "Sukar membuat permohonan baru",
    "Mahu menyusun semula kewangan"
  ]
};

export const solutionSection = {
  title: "Bagaimana Kami Membantu Anda",
  solutions: [
    {
      id: 1,
      title: "Satukan Bayaran Bulanan",
      description: "Gabungkan komitmen kepada bayaran yang lebih teratur.",
      image: "https://images.unsplash.com/photo-1579621970795-87facc2f976d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxtb25leSUyMG1hbmFnZW1lbnR8ZW58MHx8fHwxNzgwNzY2NTc0fDA&ixlib=rb-4.1.0&q=85",
      icon: "Coins"
    },
    {
      id: 2,
      title: "Susun Semula Kewangan",
      description: "Bantu mengurus komitmen mengikut kemampuan semasa.",
      image: "https://images.pexels.com/photos/7876501/pexels-photo-7876501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      icon: "TrendingUp"
    },
    {
      id: 3,
      title: "Semakan Kelayakan",
      description: "Semakan awal secara percuma.",
      image: "https://images.pexels.com/photos/5816300/pexels-photo-5816300.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      icon: "ClipboardCheck"
    },
    {
      id: 4,
      title: "Proses Mudah",
      description: "Dokumen ringkas dan proses pantas.",
      image: "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBjb25zdWx0aW5nfGVufDB8fHx8MTc4MDc2NjU2OXww&ixlib=rb-4.1.0&q=85",
      icon: "Zap"
    }
  ]
};

export const trustSection = {
  title: "Kenapa Pilih Kami?",
  benefits: [
    { text: "Semakan Awal Percuma", icon: "BadgeCheck" },
    { text: "Maklumat Sulit", icon: "Shield" },
    { text: "Proses Mudah", icon: "CheckCircle2" },
    { text: "Dokumen Ringkas", icon: "FileText" },
    { text: "Khidmat Pelanggan Mesra", icon: "Users" }
  ]
};

export const faqData = [
  {
    question: "Adakah semakan dikenakan bayaran?",
    answer: "Tidak. Semakan awal adalah percuma."
  },
  {
    question: "Siapa yang boleh memohon?",
    answer: "Penjawat awam, badan berkanun dan sektor yang berkaitan."
  },
  {
    question: "Berapa lama proses semakan?",
    answer: "Kebiasaannya dalam tempoh yang singkat selepas dokumen diterima."
  },
  {
    question: "Adakah maklumat saya selamat?",
    answer: "Ya. Semua maklumat pelanggan adalah sulit."
  }
];

export const finalCTA = {
  headline: "Jangan Biarkan Komitmen Mengganggu Kewangan Anda",
  subheadline: "Dapatkan semakan awal hari ini dan ketahui pilihan yang sesuai untuk situasi anda.",
  buttonText: "WHATSAPP SEKARANG"
};

export const employmentStatusOptions = [
  "Penjawat Awam",
  "Badan Berkanun",
  "Tentera",
  "Polis",
  "Guru",
  "Lain-lain"
];
